import { z } from "zod";

import {
	FeatureOnboardingPlacement,
	FeatureOnboardingStatus,
} from "../enum/featureOnboarding.enum";

// ── Single onboarding step ──────────────────────────────────────────

export const FeatureOnboardingStepSchema = z.object({
	id: z.number(),
	stepOrder: z.number(),
	title: z.string(),
	description: z.string(),
	targetSelector: z.string(),
	placement: z.nativeEnum(FeatureOnboardingPlacement),
	ctaLabel: z.string().nullable(),
	ctaRoute: z.string().nullable(),
	status: z.nativeEnum(FeatureOnboardingStatus),
});

export type FeatureOnboardingStep = z.infer<typeof FeatureOnboardingStepSchema>;

// ── Feature group (steps grouped by feature code) ───────────────────

export const FeatureOnboardingGroupSchema = z.object({
	featureCode: z.string(),
	steps: z.array(FeatureOnboardingStepSchema),
});

export type FeatureOnboardingGroup = z.infer<typeof FeatureOnboardingGroupSchema>;

// ── GET /feature-onboarding response ────────────────────────────────

export const FeatureOnboardingResponseSchema = z.object({
	data: z.array(FeatureOnboardingGroupSchema),
});

export type FeatureOnboardingResponse = z.infer<typeof FeatureOnboardingResponseSchema>;

// ── PATCH /feature-onboarding/:id/dismiss response ──────────────────

export const DismissStepResponseSchema = z.object({
	data: z.object({
		id: z.number(),
		featureCode: z.string(),
		stepOrder: z.number(),
		title: z.string(),
		status: z.nativeEnum(FeatureOnboardingStatus),
		dismissedAt: z.string(),
	}),
});

export type DismissStepResponse = z.infer<typeof DismissStepResponseSchema>;

// ── PATCH /feature-onboarding/dismiss-all/:featureCode response ─────

export const DismissAllResponseSchema = z.object({
	data: z.object({
		featureCode: z.string(),
		dismissedCount: z.number(),
	}),
});

export type DismissAllResponse = z.infer<typeof DismissAllResponseSchema>;
